export default "__VITE_PUBLIC_ASSET__54aa0230__"